import React, { useEffect, useState, useCallback } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import multiMonthPlugin from '@fullcalendar/multimonth';
import esLocale from '@fullcalendar/core/locales/es';
import { Alert, Col, Row, Container, Card, ListGroup, Breadcrumb } from 'react-bootstrap';
import moment from 'moment';
import toastr from 'toastr';

import CustomNavbar from '../../../components/CustomNavbar';
import SidebarDashboard from '../../../components/SidebarDashboard';
import VacationRequestForm from './vacationRequestForm';
import { useSelector, useDispatch } from "react-redux";
import "../../../css/calendar.css"
import { eventTypes } from './eventTypes';
import { requestStates } from './requestStates';
import {
  getEmployeeCalendarEvents,
  updateEmployeeCalendarEvent
} from "../../../redux/vacations/calendar_employee_events/actions";
import UserProfileAvatar from '../../../components/vacations/calendar/UserProfileAvatar';
import AsideListItem from '../../../components/vacations/calendar/AsideListItem';
import AsideColorLegend from '../../../components/vacations/calendar/AsideColorLegend';
import userPerfilImg from '../../../images/userperfil.png';
import HeaderWithSearchForm from '../../../components/header_with_search_form/HeaderWithSearchForm';

const VacationRequest = (props) => {
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEditform, setIsEditform] = useState(false);
  const [formInitialData, setFormInitialData] = useState({});
 
  const {
    isLoadingEmployeeCalendarEvents,
    employeeCalendarEventsFail,
    calendarEmployeeEvents
  } = useSelector((store) => store.calendarEmployeeEvents);

  const dispatch = useDispatch();
  const userRoles = useSelector((store) => store.auth.userRoles);
  const user = useSelector((store) => store.auth.username);

  const getCalendarEvents = useCallback(() => {
    let username;

    if (userRoles.includes("empleado")) {
      username = user;
    } else {
      username = props.match.params.username;
    }

    dispatch(getEmployeeCalendarEvents({
      filter: {
        empleado__codigo: username
      }
    }));
  }, [dispatch, props.match.params.username, user]);
  
  useEffect(() => {
    getCalendarEvents()
  }, [getCalendarEvents]);

  const onDateClick = (info) => {
    const selectedDate = info.dateStr;
    const holiday = calendarEmployeeEvents && calendarEmployeeEvents.eventsData ? calendarEmployeeEvents.eventsData.find(h => h.start === info.dateStr) : null;
    if (holiday && holiday.extendedProps.type === 'feriado') {
      toastr.error("No se pueden solicitar vacaciones, tiempo compesatorio u horas libres los domingos");
      return;
    }
    setFormInitialData({ employee_code: props.match.params.username, start: selectedDate, end: selectedDate });
    setIsEditform(false);
    setShowModal(true);
  }

  const onEventClick = (info) => {
    const event = info.event;
    const eventStart = moment(event.start).format("YYYY-MM-DD");
    const eventEnd = moment(event.end).subtract(1, "day").format("YYYY-MM-DD");
  
    const plan = event.extendedProps.tiempos_empleado_planificacion;

    const initialData = {
      id: event.extendedProps?.solicitud_id || event.id,
      employee_code: props.match.params.username,
      start: plan ? plan.fecha_inicio : eventStart,
      end: plan ? plan.fecha_fin : eventEnd,
      title: plan ? plan.titulo : event.title,
      location: plan ? plan.lugar : event.extendedProps.location,
      notes: plan ? plan.comentario : event.extendedProps.notes,
      type: plan ? plan.tipo : event.extendedProps.type,
      hours: plan ? plan.horas : event.extendedProps.hours,
      estado: event.extendedProps.estado,
    };
    
    setFormInitialData(initialData);
    setIsEditform(true);
    setShowModal(true);
  };

  const containsHoliday = (startDate, endDate) => {
    if (!calendarEmployeeEvents || !calendarEmployeeEvents.eventsData) return false;

    const holidays = calendarEmployeeEvents.eventsData.filter(h => h.extendedProps.type === 'feriado');
    return holidays.some(h => moment(h.start).isBetween(startDate, endDate, null, '[]'));
  }

  const handleEventDrop = (info) => {
    const { view } = info;
    if (view.type === 'timeGridWeek' || view.type === 'timeGridDay') {
      info.revert();
    } else {
      let startDate = moment(info.event.start).format("YYYY-MM-DD")
      let endDate = moment(info.event.end).subtract(1, "day").format("YYYY-MM-DD")

      if (containsHoliday(startDate, endDate)) {
        toastr.error("No se pueden solicitar vacaciones los domingos");
        info.revert();
        return
      }
      let req = {
        id: info.event.id,
        title: info.event.title,
        start_date: startDate,
        end_date: endDate,
        location: info.event.extendedProps.location,
        notes: info.event.extendedProps.notes,
        type: info.event.extendedProps.type,
        codigo_empleado: props.match.params.username
      }
      dispatch(updateEmployeeCalendarEvent(req.id, req));
    }
  };

  const onEventResize = (info) => {
    const { view } = info;
    if (view.type === 'timeGridWeek' || view.type === 'timeGridDay') {
      info.revert();
    } else {
      let startDate = moment(info.event.start).format("YYYY-MM-DD")
      let endDate = moment(info.event.end).subtract(1, "day").format("YYYY-MM-DD")

      if (containsHoliday(startDate, endDate)) {
        toastr.error("No se pueden solicitar vacaciones los domingos");
        info.revert();
        return
      }
      let req = {
        id: info.event.id,
        title: info.event.title,
        start_date: startDate,
        end_date: endDate,
        location: info.event.extendedProps.location,
        notes: info.event.extendedProps.notes,
        type: info.event.extendedProps.type,
        codigo_empleado: props.match.params.username
      }
      dispatch(updateEmployeeCalendarEvent(req.id, req));
    }
  }

  const handleAddEvent = () => {
    setFormInitialData({ employee_code: props.match.params.username });
    setIsEditform(false)
    setShowModal(true)
  }

  const onShowSidebar = () => setShow(show ? false : true);

  const onSearch = (e) => {
    e.preventDefault();
    getCalendarEvents(e.target.search.value);
  }

  const currentYear = moment().year();

  const calendarValidRange = {
      start: `${currentYear}-01-01`,
      end: `${currentYear + 1}-01-01`
  };

  const handleCloseModal = () => {
    setShowModal(false);
    getCalendarEvents();
  };

  const eventsWithStateColor = (calendarEmployeeEvents?.eventsData || []).map(ev => {
    const estado = ev.extendedProps?.estado?.toLowerCase(); 
    const stateColor = requestStates[estado]?.color || "#6c757d"; 

    return {
      ...ev,
      color: stateColor, 
    };
  });

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          {employeeCalendarEventsFail && (
            <Alert variant="danger" className={"mt-3 mb-3 mx-3"}>
              {employeeCalendarEventsFail}
            </Alert>
          )}
          <div className="mb-3">  
            <HeaderWithSearchForm 
              onSearch={onSearch} 
              title="Solicitar vacaciones"
              showNewRecordButton={true}
              onAdd={handleAddEvent} />
          </div>
          <section>
            <Row>
              <Col as="aside" md={3} sm={12}>
                <Card className="mb-2">
                  <Card.Body>
                    <UserProfileAvatar 
                      profileImgUrl={calendarEmployeeEvents?.userData?.foto ? `${process.env.REACT_APP_URL}${calendarEmployeeEvents.userData.foto}` : userPerfilImg}
                      name={calendarEmployeeEvents?.userData?.nombre || "No encontrado"} 
                      jobFunc={calendarEmployeeEvents?.userData?.puesto || "..."} />
                  </Card.Body>
                </Card>
                <h6 className='pl-1 mb-1'>Vacaciones</h6>
                <ListGroup className="mb-2">
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Disponibles || 0} text={"Disponibles"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Disfrutados || 0} text={"Disfrutados"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Pendientes || 0} text={"Pendientes"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Programados || 0} text={"Programado"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Cumplimiento || 0} text={"Cumplimiento"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEvents?.Total || 0} text={"Total"} />
                </ListGroup>
                <h6 className='pl-1 mb-1'>Tiempos compensatorios</h6>
                <ListGroup className="mb-2">
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEventsCompensatoryTimes?.tiempo_compensatorio_disponible || 0} text={"Disponibles"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEventsCompensatoryTimes?.tiempo_compensatorio_restante || 0} text={"Pendientes"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEventsCompensatoryTimes?.tiempo_compensatorio_programados || 0} text={"Programado"} />
                  <AsideListItem itemCount={calendarEmployeeEvents?.kpiEventsCompensatoryTimes?.tiempo_compensatorio_cumplimiento || 0} text={"Cumplimiento"} />
                </ListGroup>
                <Card>
                  <Card.Body>
                    {
                      (Object.values(requestStates)).map(({ name, color }, index) => ( 
                        <AsideColorLegend key={index} color={color} name={name} />
                      ))
                    }
                  </Card.Body>
                </Card>
              </Col>
              <Col as="main" md={9} sm={12}>
                <Card>
                  <Card.Body>
                    <FullCalendar
                      loading={isLoadingEmployeeCalendarEvents}
                      plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin, multiMonthPlugin]}
                      initialView="dayGridMonth"
                      validRange={calendarValidRange}
                      headerToolbar={{
                        left: 'prev,next today',
                        center: 'title',
                        right: 'multiMonthYear,dayGridMonth,timeGridWeek,timeGridDay'
                      }}
                      weekends={true}
                      multiMonthMinWidth={2}
                      locales={[esLocale]}
                      locale={'es'}
                      /*events={calendarEmployeeEvents?.eventsData || []}*/
                      events={eventsWithStateColor}
                      eventContent={(arg) => {
                        const solicitudId = arg.event.extendedProps?.solicitud_id;
                        return {
                          html: `<div><strong>Solicitud #${solicitudId}</strong> ${arg.event.title}</div>`
                        };
                      }}
                      editable={true}
                      eventDrop={handleEventDrop}
                      businessHours={[
                        {
                          daysOfWeek: [1, 2, 3, 4, 5],
                          startTime: '08:00',
                          endTime: '17:00',
                        },
                        {
                          daysOfWeek: [6], 
                          startTime: '08:00',
                          endTime: '12:00',
                        }]}
                      dateClick={onDateClick}
                      eventClick={onEventClick}
                      eventResize={onEventResize} />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </section>
          <VacationRequestForm
            avaibleVac={calendarEmployeeEvents?.kpiEvents?.Disponibles || 0}
            avaibleCT={calendarEmployeeEvents?.kpiEventsCompensatoryTimes?.tiempo_compensatorio_disponible || 0}
            isEditForm={isEditform} 
            setShowModal={handleCloseModal} 
            showModal={showModal} 
            formInitialData={formInitialData} 
            eventTypes={eventTypes} />
        </Container>
      </div>
    </>
  )
}

export default VacationRequest